import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import Customers from './pages/Customers';
import Merchants from './pages/Merchants';
import Dashboard from './pages/Dashboard';
import ScrollToTop from './components/common/ScrollToTop';
import { AuthProvider } from './contexts/AuthContext';
import PartnerBrands from './pages/PartnerBrands';
import { initGA, pageview } from './utils/analytics';
import './styles/globals.css';

// Component to track page views
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    pageview(location.pathname);
  }, [location]);

  return null;
};

const App: React.FC = () => {
  useEffect(() => {
    // Initialize Google Analytics
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (measurementId) {
      initGA(measurementId);
    }
  }, []);

  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <PageViewTracker />
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Customers />} />
              <Route path="/merchant" element={<Merchants />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/partner-brands" element={<PartnerBrands />} />
              {/* Catch-all route - redirects all unsupported routes to home page */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;